import React from "react";
import { hideSuccess, getIsSuccess, getSuccessMessage } from "./notificationsSlice";

import { useSelector, useDispatch } from "react-redux";

import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import MuiAlert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const SuccessNotification = () => {
  const dispatch = useDispatch();
  const isSuccess = useSelector(getIsSuccess);
  const successMessage = useSelector(getSuccessMessage)

  function handleClose() {
    dispatch(hideSuccess());
  }

  return (
    <>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar open={isSuccess} anchorOrigin={{ vertical: "bottom", horizontal: "left" }} TransitionComponent={Transition} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
            {successMessage}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
};
